import fpsPayeeMock from "../mock_data/fpsPayee";
import purposeCodes from "../mock_data/purposeCodes";

export default function getSavedPayee(setChosenPayee, setScreen, setWaitingForPayee, setError, payeeId, setPurposeCodes, setAskIsCard){
    if (!window.OrendaGetResponse || window.isSiteBuilder) {
      setTimeout(() => {
        setChosenPayee(fpsPayeeMock);
        setScreen("Payment");
        setPurposeCodes(purposeCodes);
        setWaitingForPayee(false);
      }, 1000);
      return;
    }

    window.OrendaGetResponse(
      { event_name: "getSavedPayee", data: JSON.stringify({ payeeId }) },
      (response) => {
        if (response.error) return setError(true);
        setChosenPayee(response.payee);
        setAskIsCard(response.payee.askIsCard);
        setScreen("Payment");
        setPurposeCodes(response.purpose_codes);
        setWaitingForPayee(false);
        return;
      }
    );
}